export default {"src":"/_next/static/media/honeydew.232cd29c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};